import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminMainLayout from './AdminMainLayout';

const AdminDashboard = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (!token) {
            navigate('/admin/login');
        }
    }, [navigate]);

    return (
        <AdminMainLayout>
            <h1 className="text-3xl font-bold mb-4">Admin Dashboard</h1>
            <p className="text-gray-700">Welcome to the Sun Flower Beach Resort admin panel. Use the sidebar to manage Events and Gallery.</p>
        </AdminMainLayout>
    );
};

export default AdminDashboard;